import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const reminder = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 150
        },
        {
            title: '标题',
            dataIndex: 'title',
            key: 'title',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.title || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '是否完成',
            dataIndex: 'doneFlag',
            key: 'doneFlag',
            scopedSlots: {
                filterDropdown: 'filterDropdownBool',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'doneFlag'
            },
            filteredValue: filteredInfo.doneFlag || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },

        {
            title: '发票记录',
            dataIndex: 'invoiceRecordId',
            key: 'invoiceRecordId',
            scopedSlots: {
                // filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'invoiceRecordId'
            },
            filteredValue: filteredInfo.invoiceRecordId || [],
            // sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '邮寄信息',
            dataIndex: 'mailInfoId',
            key: 'mailInfoId',
            scopedSlots: {
                // filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'mailInfoId'
            },
            filteredValue: filteredInfo.mailInfoId || [],
            // sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },

        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'id',
        //     sorter: true,
        //     sortDirections: ["descend", "ascend", "descend"]
        // },


        {
            title: '日期完成情况',
            dataIndex: 'remindersTimes',
            key: 'remindersTimes',
            scopedSlots: {
                customRender: 'remindersTimes'
            },
            width: 150
        },

        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
